import * as React from 'react';
import { useEffect, useRef } from 'react';

import { use$ } from '@legendapp/state/react';
import styled from 'styled-components';

import { DraggingEvent, useDragEvent } from '../../hooks/use-drag-event';

import { ContentId, ProductView, TrackingEventName } from '../../store/stores/tracking/types';

import { degreeImageStore, degreeImageStoreActions } from '../../store';
import { trackingStore } from '../../store/stores/tracking-store';
import DegreeImageComponent from './degree-image-component';

const DegreeImageContainer = () => {
	const elementRef = useRef<HTMLDivElement>(null);
	const currentDegree = use$(degreeImageStore.currentDegree) || 0;

	function moveBy(steps: number) {
		let newDegree = (currentDegree + steps * 10) % 360;
		if (newDegree < 0) newDegree += 360;
		degreeImageStoreActions.setCurrentDegree(newDegree);
	}

	const dragState = useDragEvent(elementRef, {
		onDragging: (e: DraggingEvent) => {
			moveBy(e.direction === 'left' ? 1 : -1);
		},
		onDragStart: () => {
			trackingStore.track(TrackingEventName.VISUALIZER_ROTATE_CLICK, {
				contentId: ContentId.IMAGE_BASED_VIEW,
				sectionName: ProductView.EXTERNAL_VIEW
			});
		}
	});

	// TODO: let's try and remove the useEffects
	useEffect(() => {
		const handleKeyboard = (e: KeyboardEvent) => {
			if (e.key === 'ArrowRight') moveBy(-1);
			if (e.key === 'ArrowLeft') moveBy(1);
		};

		window.addEventListener('keydown', handleKeyboard);
		return () => window.removeEventListener('keydown', handleKeyboard);
	}, [currentDegree]);

	return (
		<DegreeImageWrapper ref={elementRef} isPanning={use$(dragState.isDragging)}>
			<DegreeImageComponent />
		</DegreeImageWrapper>
	);
};

const DegreeImageWrapper = styled.div<{ isPanning?: boolean }>`
	overflow: hidden;
	grid-column: 1 / -1;
	grid-row: 1 / -1;
	cursor: ${props => (props.isPanning ? 'grabbing' : 'grab')};

	// This solves dragging up and down while dragging left/right
	touch-action: none;
`;

export default DegreeImageContainer;
